/* eslint-disable @typescript-eslint/naming-convention */
// default values for components

const pageSizeOptions = [20, 50, 100];

export const PAGINATOR = {
  DEFAULT_PAGE: 1,
  DEFAULT_PAGE_SIZE: pageSizeOptions[0],
  PAGE_SIZE_OPTIONS: pageSizeOptions,
};

export const TABLE = {
  REQUEST_DELAY: 200,
};

export const INPUT = {
  SELECT: {
    SEARCH: {
      MIN_LENGTH: 2,
      DEBOUNCE_TIME: 1500,
    },
  },
};

export const MODAL = {
  WIDTH: "500px",
};

export const yesNoOptions = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];
